<template>
  <div
    :data-tabs-content="`boss-tabs-control-${suffix}`"
    class="tabs-content boss-tabs-content-job-selected"
    data-test="control"
  >
    <select-modal-contents-categories
      v-for="(categories, index) in masterData"
      :key="index"
      :suffix="suffix"
      :categories-data-map="masterDataMap[categories.id]"
      :categories="categories"
      :depth="depth"
      :experience-range-options="experienceRangeOptions"
      :default-experience-id="defaultExperienceId"
      :is-active="index===0"
      class="tabs-panel boss-tabs-panel"
      @update-categories="updateCategories"
    />
  </div>
</template>

<script>
import SelectModalContentsCategories from '@/components/molecules/SelectModalContentsCategories'

export default {
  components: {
    SelectModalContentsCategories
  },
  props: {
    suffix: {
      type: String,
      required: true
    },
    masterData: {
      type: Array,
      required: true
    },
    masterDataMap: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      required: true
    },
    experienceRangeOptions: {
      type: Array,
      default: () => ([])
    },
    defaultExperienceId: {
      type: String,
      default: ''
    }
  },
  methods: {
    updateCategories (data) {
      this.$emit('update-master-data-map', { ...this.masterDataMap, [data.id]: data.value })
    }
  }
}
</script>
